import { useMemo } from 'react';

/**
 * 帳票の「発行日付 / 発行時刻」を現在時刻から生成する。
 * - issueDate: YYYY/MM/DD
 * - issueTime: HH:MM:SS
 *
 * 複数の帳票 Page で同じロジックを使うため共通化している。
 */
export type IssueDateTime = {
  issueDate: string;
  issueTime: string;
};

export function formatIssueDateTime(now: Date): IssueDateTime {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const mm = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');
  return { issueDate: `${y}/${m}/${d}`, issueTime: `${hh}:${mm}:${ss}` };
}

/** マウント時の現在時刻をフォーマットして返す。 */
export function useIssueDateTime(): IssueDateTime {
  return useMemo(() => formatIssueDateTime(new Date()), []);
}
